/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineDefinition extends models.BaseDefinition {
    getFixupPrototypeFunction() { return TagBaselineDefinition.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineDefinition>): TagBaselineDefinition {
        let obj = Object.assign(new TagBaselineDefinition(), model);
        TagBaselineDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineDefinition>): TagBaselineDefinition {
        if (!model) return null;
        return TagBaselineDefinition.newInstance(<TagBaselineDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineDefinition) {
        if (!obj) return;

        models.TagBaselineDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineDefinition): boolean {
        if (models.BaseDefinition.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.scope) {
            models.TagBaselineScope.fixupPrototype(this.scope);
        }
    }

    /**
     * Account owning the tag baseline
     */
    account_id: string;

    /**
     * Name of the baseline
     */
    title: string;

    /**
     * Description of the baseline
     */
    description: string;

    /**
     * At what scope level the baseline should work
     */
    scope: models.TagBaselineScope;

    /**
     * States if the baseline definition is active or not
     */
    is_active: boolean;

}
